import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  genericError: {
    id: 'masquerade-widget.userName.error.generic',
    defaultMessage: 'An error has occurred; please try again.',
    description: 'Message shown after a general error when attempting to masquerade',
  },
  placeholder: {
    id: 'masquerade-widget.userName.input.placeholder',
    defaultMessage: 'Username or email',
    description: 'Placeholder text to prompt for a user to masquerade as',
  },
  userNameLabel: {
    id: 'masquerade-widget.userName.input.label',
    defaultMessage: 'Masquerade as this user',
    description: 'Label for the masquerade user input',
  },
  ViewCourseAsLabel: {
    id: 'masquerade-widget.useCourseAs.label',
    defaultMessage: 'View this course as:',
    description: 'Label for the masquerade use course buttun',
  },
  ViewCourseAsSpecificStudent: {
    id: 'masquerade-widget.userCourseAs.registeredStudent',
    defaultMessage: 'Specific Student...',
    description: 'Label for the masquerade open course as dropdown',
  },
  ViewCourseAsSpecificStuff: {
    id: 'masquerade-widget.userCourseAs.stuff',
    defaultMessage: 'Staff',
    description: 'Label for the masquerade open course as dropdown',
  },
  ViewCourseAsFreeListener: {
    id: 'masquerade-widget.userCourseAs.freeListener',
    defaultMessage: 'Free Listener',
    description: 'Label for the masquerade open course as dropdown',
  },
});

export default messages;
